import { Link } from 'react-router-dom';

const team = [
  { name: 'Nzoyishemeza Vital',      role: 'Chief Executive Officer',       dept: 'Leadership',    color: 'green' as const, initials: 'NV' },
  { name: 'Kwizera Audry',           role: 'Chief Technology Officer',      dept: 'Engineering',   color: 'red'   as const, initials: 'KA' },
  { name: 'Ngabonziza Pontien',      role: 'Head of Communications',        dept: 'Marketing & PR',color: 'green' as const, initials: 'NP' },
  { name: 'Nishimwe Gloria',         role: 'Chief Financial Officer',       dept: 'Finance',       color: 'red'   as const, initials: 'NG' },
  { name: 'Izonkiza Fidela',         role: 'Head of Equipment Security',    dept: 'Operations',    color: 'green' as const, initials: 'IF' },
  { name: 'Ir Irakoze Jean de Dieu', role: 'Web & Publications Manager',    dept: 'Digital',       color: 'red'   as const, initials: 'IJ' },
];

/* small circuit decoration */
const MiniCircuit = () => (
  <svg viewBox="0 0 120 60" className="absolute bottom-2 right-2 h-10 w-20 opacity-[0.06]" aria-hidden="true" fill="none">
    <polyline points="0,30 30,30 30,10 80,10 80,30 120,30" stroke="#1aa534" strokeWidth="2" />
    <polyline points="30,30 30,50 70,50 70,30" stroke="#d2252e" strokeWidth="1.5" />
    <circle cx="30" cy="30" r="4" fill="#1aa534" />
    <circle cx="80" cy="10" r="4" fill="#d2252e" />
  </svg>
);

const TeamPage = () => (
  <div className="bg-white">

    {/* ── Page header ── */}
    <div className="border-b border-slate-200 bg-slate-50 py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <span className="section-label">Our Team</span>
        <h1 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">The BETRobionics Team</h1>
        <p className="mt-3 max-w-2xl text-slate-500 leading-6">
          A dedicated team of engineers, managers, and innovators committed to building
          Africa's technology future from Burundi.
        </p>
      </div>
    </div>

    {/* ── Team grid ── */}
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((member, i) => {
            const isGreen = member.color === 'green';
            const ac = isGreen ? '#1aa534' : '#d2252e';
            return (
              <article key={member.name}
                className="relative overflow-hidden rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md animate-fade-in-up"
                style={{ animationDelay: `${i * 60}ms` }}>
                <MiniCircuit />
                <div className="flex items-center gap-4">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl text-lg font-bold text-white shadow-sm"
                    style={{ background: ac }}>
                    {member.initials}
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">{member.name}</p>
                    <p className="text-sm font-medium" style={{ color: ac }}>{member.role}</p>
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-slate-500">
                    {member.dept}
                  </span>
                  <div className="flex items-center gap-1.5">
                    <span className="h-2 w-2 rounded-full animate-pulse" style={{ background: ac }} />
                    <span className="text-[11px] text-slate-400">Active</span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {/* Join us */}
        <div className="mt-14 rounded-2xl border border-slate-200 bg-slate-50 p-10 text-center">
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#1aa534]/10">
            <svg className="h-7 w-7 text-[#1aa534]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-slate-900">Join the BETRobionics Team</h2>
          <p className="mt-3 mx-auto max-w-lg text-slate-500 leading-7">
            Passionate about IoT, robotics, AI or electronics? We are always looking for talented
            people who want to build the technological future of Africa.
          </p>
          <Link to="/contact" className="btn-primary-lg mt-7 inline-flex">Get in Touch →</Link>
        </div>
      </div>
    </section>
  </div>
);

export default TeamPage;
